<template>
  <Modal
    v-model="modalShow"
    title="选择套餐"
    @on-ok="ok"
    @on-cancel="cancel"
  >
    <p class="choose-suit-title">请先选择主套餐类型</p>
    <el-row type="flex" :gutter="20" class="wrapper">
      <el-col :span="8" v-for="item of packageList" :key="item.id" :lg="8" :xs="24" :sm="24" :md="12">
        <div  @click="changeActiveIndex(item)" :class="(linkPath.query.packageId == item.id)?'package-box active':'package-box'">
          <div class="package-div">
            <div class="package-top">
              <div class="package-title">
                <div :class="(linkPath.query.packageId == item.id)?'main-text active':'main-text'">{{getMainText(item.name)}}</div>
                <div  :class="(linkPath.query.packageId == item.id)?'main-text active':'main-text'">{{getSubText(item.name)}}</div>
              </div>
              <div class="price-div"><span class="price-span">{{getRMBFormate(item.price)}}</span>元/
                <template>
                  <span>{{item.num}}</span>{{ item.dateTypeStr }}
                </template>
              </div>
            </div>
            <div class="comm-box">
              <div class="comm-div border-top-eee">利润分佣{{item.commissionRate}}%</div>
            </div>
            <div class="triangle" v-show="(linkPath.query.packageId == item.id)">
              <span class="el-icon-check triangle-icon"></span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="package-basic-info">
      <div class="package-basic-title">套餐费用合计：</div>
      <div class="package-basic-price">
        <span class="price-icon">￥</span>{{activeTotalMoney}}
      </div>
    </div>

    <router-link tag="div" :to="linkPath">
      <a target="_blank">
        <div class="go-to-pay">
          <span class="pay-btn">去支付</span>
        </div>
      </a>
    </router-link>

    <div slot="footer">

    </div>
  </Modal>
</template>

<script>
import { getPlatformUuid } from '@/utils/auth'
import { Modal } from 'view-design'
export default {
  name: "ActivationItem",
  components:{
    Modal
  },
  data(){
    return {
      modalShow: false,
      packageList:[],
      activeTotalMoney: '0.00',
      profitObj:{},
      linkPath:{
        path:'/pc/channelMiniProgram/pay',
        query:{
          platformUuid:getPlatformUuid(),
          isProfit: 0,
          packageId:0,
          type: 4,
          profitPackageId:0
        }
      },
      isSupportContinue:0
    }
  },
  methods:{
    init(pageList,item,isProfit,profitObj){
      console.log('item',item)
      this.linkPath.query.isProfit = isProfit
      this.profitObj = profitObj
      this.packageList = pageList
      // 默认选中第一个
      this.changeActiveIndex(this.packageList[0])
      this.modalShow = true
      this.linkPath.query.profitPackageId = item.id
    },
    ok () {
      this.$Message.info('Clicked ok');
    },
    cancel () {
      this.packageList = []
      this.modalShow = false
    },
    getRMBFormate(money){
      return parseFloat(money).toFixed(2)
      return money
    },
    changeActiveIndex(item){
      console.log('item',item)
      this.linkPath.query.packageId = (item.id)?item.id:0
      let totalMoney = parseFloat(item.price)
      console.log('totalMoney',totalMoney)
      if(this.linkPath.query.isProfit == 1){
        // 购买分销套餐
        totalMoney+=parseFloat(this.profitObj.price)
        console.log('this.profitObj.price',this.profitObj)
        console.log('this.profitObj',parseFloat(this.profitObj.price))
      }
      console.log('totalMoney',totalMoney)
      this.activeTotalMoney = this.getRMBFormate(totalMoney)
      this.isSupportContinue = item.isSupportContinue
    },
    getMainText(item){
      return item.substr(0,8)
    },
    getSubText(item){
      let lastLen = (item.length>=32)?32:item.length
      return item.substr(8,lastLen)
    }
  }
}
</script>

<style scoped>
/*修改插件内的样式*/
>>>.ivu-modal-body{
  padding:0
}
>>>.ivu-modal{
  width: 66.444vw !important;
}
>>>.ivu-modal-footer{
  border-top:none;
  margin-top:43px;
}
/*end*/
.wrapper{
  padding: 0 40px;
  flex-wrap: wrap;
}
>>>.wrapper .el-col{
  margin-bottom: 30px;
}
.choose-suit-title{
  font-family: Alibaba-PuHuiTi-M;
  font-size: 20px;
  color: #222222;
  margin: 20px 40px;
}
.is-need-seller {
  margin-left: 30px;
}
.is-need-seller .radio-text{
  margin-right: 30px;
}
.wrapper .package-box{
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  color: #222222;
  text-align: center;
  font-family: Alibaba-PuHuiTi-M;
  border-radius: 4px;
  font-size: 24px;
  width: 247px;
  height: 245px;
}
.wrapper .package-box.active{
  background: #FFFBF7;
  border: 1px solid #FF8622;
  color: #FF8622;
}
.wrapper .package-box.active .package-title{
  color: #FF8622;
}
.wrapper .package-box .package-title{
  height: 91px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  word-break: break-all;
}
.wrapper .package-box .package-title .main-text{
  font-family: Alibaba-PuHuiTi-M;
  font-size: 24px;
  width: 100%;
  word-break: break-all;
}
.wrapper .package-box.active  .package-title .main-text{
  color: #FF8622;
}

.wrapper .package-box .package-title .sub-text{
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  word-break: break-all;
}
.sub-text.active,.main-text.active{
  color: #FF8622;
}
.wrapper .package-box.active .package-title .sub-text{
  color: #FF8622;
}
.wrapper .package-div{
  /* padding: 0 20px; */
  position: relative;
  cursor: pointer;
  height: 100%;
}
.wrapper .package-box.active .package-div{
  color: #FF8622;
}
.wrapper .package-div .package-top{
  /*padding: 40px 20px;*/
}
.wrapper .package-div .package-bottom{
  padding: 30px 20px;
}
.wrapper .package-div .package-title{
  font-size: 18px;
  padding-top: 20px;
}

.wrapper .package-div .triangle{
  color: #fff;
  width: 0;
  height: 0;
  border: 14px solid #FF8622;
  border-left: 14px solid transparent;
  border-top: 14px solid transparent;
  position: absolute;
  bottom: 0;
  right: 0;
}
.wrapper .package-box .triangle .triangle-icon{
  position: relative;
  top: -15px;
  font-size: 15px;
  right:1px;
}
.package-basic-info{
  font-family: Alibaba-PuHuiTi-M;
  display: flex;
  align-items: center;
  margin:40px;
}
.package-basic-info .package-basic-title{
  font-family: Alibaba-PuHuiTi-M;
  font-size: 20px;
  color: #222222;
}
.package-basic-info  .package-basic-price{
  font-family: Alibaba-PuHuiTi-M;
  font-size: 32px;
  color: #FF4F76;
  line-height: 44px;
}
.package-basic-info  .package-basic-price .price-icon{
  font-size: 16px;
}
.go-to-pay{
  display: flex;
  justify-content: center;
  align-items: center;
}
.go-to-pay .pay-btn{
  background: #FF8622;
  border-radius: 2px;
  color: #fff;
  height: 36px;
  font-family: Alibaba-PuHuiTi-R;
  font-size: 16px;
  width: 205px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.comm-box{
  margin-top: 59px;
}
.comm-div{
  font-size: 18px;
  font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
  font-weight: normal;
  line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/channelMiniProgram/dialog/index.vue